import React from 'react';
export function DisclaimerSection() {
  return <section className="py-12 px-4 bg-white border-t border-cream-200" data-id="element-8">
      <div className="max-w-4xl mx-auto text-center" data-id="element-9">
        <p className="text-sm text-stone-400" data-id="element-10">
          Este material es educativo y no constituye asesoría financiera, legal
          o profesional. Resultados varían según ejecución y contexto.
        </p>
      </div>
    </section>;
}